import { useEffect, useState } from "react";
import { FaSave } from "react-icons/fa";

export default function RegistroEntrada({ servicio, onGuardado }) {

  const [miembros, setMiembros] = useState([]);
  const [toast, setToast] = useState({ mostrar: false, mensaje: "", tipo: "success" });

  const [form, setForm] = useState({
    id_miembro: "",
    diezmo: "",
    misiones: "",
    protemplo: "",
    ofrenda: "",
    biblia: "",
    especial: ""
  });

  const inputClass =
    "w-full border border-slate-200 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-200 focus:border-indigo-400";

  const mostrarToast = (mensaje, tipo = "success") => {
    setToast({ mostrar: true, mensaje, tipo });
    setTimeout(() => setToast({ mostrar: false, mensaje: "", tipo: "success" }), 3000);
  };

  // ============================
  // Cargar miembros
  // ============================

  useEffect(() => {
    cargarMiembros();
  }, []);

  const cargarMiembros = async () => {
    try {
      const res = await fetch("/api/miembros", {
        credentials: "include",
      });

      const data = await res.json();
      setMiembros(data);

    } catch (error) {
      console.error("Error cargando miembros", error);
    }
  };

  // ============================
  // Cambios formulario
  // ============================

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // ============================
  // Guardar registro
  // ============================

  const guardarRegistro = async () => {

    if (!servicio) {
      mostrarToast("Selecciona un servicio", "error");
      return;
    }

    if (!form.id_miembro) {
      mostrarToast("Selecciona un miembro", "error");
      return;
    }

    const datos = {
      diezmo: Number(form.diezmo || 0),
      misiones: Number(form.misiones || 0),
      protemplo: Number(form.protemplo || 0),
      ofrenda: Number(form.ofrenda || 0),
      biblia: Number(form.biblia || 0),
      especial: Number(form.especial || 0)
    };

    const total =
      datos.diezmo +
      datos.misiones +
      datos.protemplo +
      datos.ofrenda +
      datos.biblia +
      datos.especial;

    try {
      const res = await fetch("/api/finanzas", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_servicio: servicio,
          id_miembro: form.id_miembro,
          ...datos,
          total
        })
      });

      if (!res.ok) {
        mostrarToast("Error guardando el registro", "error");
        return;
      }

      mostrarToast("Registro guardado correctamente");

      setForm({
        id_miembro: "",
        diezmo: "",
        misiones: "",
        protemplo: "",
        ofrenda: "",
        biblia: "",
        especial: ""
      });

      if (onGuardado) onGuardado();

    } catch (error) {
      console.error("Error guardando registro", error);
      mostrarToast("Error de conexión con el servidor", "error");
    }
  };

  // ============================
  // UI
  // ============================

  return (
    <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
      <h2 className="text-base font-semibold text-slate-800 mb-4">Registro de entrada</h2>

      {toast.mostrar && (
        <div className={`fixed top-5 right-5 z-[70] px-4 py-3 rounded-lg shadow-lg text-sm text-white ${toast.tipo === "success" ? "bg-emerald-600" : "bg-rose-600"}`}>
          {toast.mensaje}
        </div>
      )}

      <div className="space-y-3">

        {/* miembro */}
        <div>
          <label className="block text-xs font-medium text-slate-700 mb-1">Miembro</label>
          <select
            name="id_miembro"
            value={form.id_miembro}
            onChange={handleChange}
            className={inputClass}
          >
            <option value="">Seleccionar miembro</option>
            {miembros.map((m) => (
              <option key={m.id_miembro} value={m.id_miembro}>
                {m.nombre} {m.paterno} {m.materno}
              </option>
            ))}
          </select>
        </div>

        {/* montos */}
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Diezmo</label>
            <input type="number" name="diezmo" value={form.diezmo} onChange={handleChange} className={inputClass} />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Misiones</label>
            <input type="number" name="misiones" value={form.misiones} onChange={handleChange} className={inputClass} />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Pro templo</label>
            <input type="number" name="protemplo" value={form.protemplo} onChange={handleChange} className={inputClass} />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Ofrenda</label>
            <input type="number" name="ofrenda" value={form.ofrenda} onChange={handleChange} className={inputClass} />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Biblia</label>
            <input type="number" name="biblia" value={form.biblia} onChange={handleChange} className={inputClass} />
          </div>
          <div>
            <label className="block text-xs font-medium text-slate-700 mb-1">Especial</label>
            <input type="number" name="especial" value={form.especial} onChange={handleChange} className={inputClass} />
          </div>
        </div>

        <button
          onClick={guardarRegistro}
          className="w-full flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium py-2 rounded-lg transition"
        >
          <FaSave className="text-xs" /> Guardar registro
        </button>
      </div>
    </div>
  );
}
